import { ICountryCode } from './interfaces';

export const COUNTRY_CODE_LIST: ICountryCode = {
    countryCodeOptions: [],
};
